import { useCan } from './useCan';

/**
 * Quem pode abrir o Financeiro — `financeiro.ver` na oficina ativa, o mesmo que
 * a API exige (`requireFinanceAccess`). Antes o menu perguntava o papel global
 * da conta e divergia da API; desde a Fase 3 é a permissão da oficina
 * (`useCan`), que cobre o gestor, o Financeiro e quem o gestor liberou.
 *
 * Isto é conveniência de navegação, não autorização: a autoridade é a API.
 */
export function useCanViewFinance(): boolean {
  return useCan()('financeiro.ver');
}
